<template>
  <div
    :key="tag.id"
    class="bg-static-default-low rounded-full caption mr-8 mt-8 flex w-fit items-center p-4 pr-8 text-center md:body-2"
  >
    <DynamicIcon class="h-16 w-16 shrink-0" :icon="tag.icon" />
    <span class="ml-4 text-left">
      {{ tag.text }}
    </span>
  </div>
</template>

<script setup lang="ts">
import DynamicIcon from '~/scopes/product/components/CustomizationFunnel/components/DynamicIcon/DynamicIcon.vue'

defineProps<{
  tag: {
    id: string
    text: string
    icon: string
  }
}>()
</script>
